import React from "react";
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import PrivateRoute from "./pages/PrivateRoute";
import Login from "./pages/Login";
import UsedVehicles from "./pages/usedVehicles/UsedVehicles";
import FindAndPrint from "./pages/findAndPrint/FindAndPrint";
import Settings from "./pages/settings/Settings";
import OrderSupplies from "./pages/orderSupplies/OrderSupplies";
import Contacts from "./pages/contacts/Contacts";
import PrintHistory from "./pages/printHistory/PrintHistory";

const App = () => {
    const isAuth = localStorage.getItem("isAuth");
    return (
        <>
            <Router>
                <Route path="/page/login" component={Login} />
                <Switch>
                    <PrivateRoute  path="/" exact component={UsedVehicles} isAuth={isAuth} />
                    <PrivateRoute  path="/page/UsedVehicles" component={UsedVehicles} isAuth={isAuth} />
                    <PrivateRoute  path="/page/FindAndPrint" component={FindAndPrint} isAuth={isAuth} />
                    <PrivateRoute  path="/page/Settings" component={Settings} isAuth={isAuth} />
                    <PrivateRoute  path="/page/orderSupplies" component={OrderSupplies} isAuth={isAuth} />
                    <PrivateRoute  path="/page/contacts" component={Contacts} isAuth={isAuth} />
                    <PrivateRoute  path="/page/history" component={PrintHistory} isAuth={isAuth} />
                </Switch>
            </Router>

        </>
    );
}

export default App;